import { render, staticRenderFns } from "./ViewInventory.vue?vue&type=template&id=e85e6082"
import script from "./ViewInventory.vue?vue&type=script&lang=js"
export * from "./ViewInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports